// ============================================
// RenderContext Factory
// ============================================

import { type IRenderContext, type RenderContextOptions, isWebGPUAvailable } from './IRenderContext';
import { WebGPURenderContext } from './WebGPURenderContext';

/**
 * Create a WebGPU render context
 */
export async function createRenderContext(options: RenderContextOptions): Promise<IRenderContext> {
  if (!isWebGPUAvailable()) {
    throw new Error('WebGPU is not available in this browser');
  }
  return WebGPURenderContext.create(options);
}


// Re-export for convenience
export { WebGPURenderContext } from './WebGPURenderContext';
export { type IRenderContext, type RenderContextOptions, isWebGPUAvailable } from './IRenderContext';

// Legacy alias — now points to WebGPURenderContext
export { WebGPURenderContext as RenderContext } from './WebGPURenderContext';
